import { ArrowDown } from "lucide-react";
import { HeroSlider } from "@/components/HeroSlider";
import { Opportunity, Results, Versus, Demand } from "@/components/HomeSections";
import { scrollToTarget } from "@/components/SmoothScroll";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <HeroSlider action={
        <button type="button" className="kh-btn-primary" onClick={() => scrollToTarget(document.querySelector("[data-testid=home-opportunity]"))} data-testid="hero-continue-button">
          Continue <ArrowDown size={16} className="kh-arrow-down" aria-hidden="true" />
        </button>
      } />
      <Opportunity />
      <Results />
      <Versus />
      <Demand />
    </main>
  );
}
